/**
 * This is a temporary gate while we transition from the old NPS
 * to the new dashboard.
 * Once the new NPS is ungated, this should be removed and
 * use NpsDashboard directly instead
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectAccountFeature } from 'reducers/account/features';
import { NPS_DASHBOARD } from 'constants/features';

import SatisfactionSurveysIndex from 'components/SatisfactionSurveys/SatisfactionSurveysIndex';
import NpsDashboard from './NpsDashboard';

const DashboardGate = ({ hasNewNpsDashboard = false }) => {
  if (hasNewNpsDashboard) {
    return <NpsDashboard />;
  }

  return <SatisfactionSurveysIndex />;
};

DashboardGate.propTypes = {
  hasNewNpsDashboard: PropTypes.bool,
};

const mapStateToProps = state => ({
  hasNewNpsDashboard: selectAccountFeature(state, NPS_DASHBOARD),
});

export default connect(mapStateToProps)(DashboardGate);
